import { PositiveColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { FontWeights } from '@picsart/design-system/foundation/fonts';

import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useTemplateHeadingStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      borderRadius: CornerRadius.r12,
    },
    filterAndSearchbarContainer: {
      display: 'flex',
      gap: Spacings.s8,
      justifyContent: 'center',
      alignItems: 'center',
      [BreakPointsMedia.SM]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
      [BreakPointsMedia.XS]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
      [BreakPointsMedia.XXS]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
    bannerContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      // max width for search input
      maxWidth: 746,
      gap: Spacings.s16,
      paddingTop: Spacings.s24,
    },
    title: {
      fontWeight: FontWeights.semibold,
      fontSize: FontSizes.s36,
      color: PositiveColors.text.default,
      lineHeight: LineHeights.l50,
      textAlign: 'center',

      [BreakPointsMedia.MD]: {
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
      [BreakPointsMedia.SM]: {
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
      [BreakPointsMedia.XS]: {
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
      [BreakPointsMedia.XXS]: {
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    description: {
      fontWeight: FontWeights.medium,
      fontSize: FontSizes.s16,
      color: PositiveColors.text.default,
      lineHeight: LineHeights.l24,
      textAlign: 'center',

      [BreakPointsMedia.MD]: {
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,
      },
      [BreakPointsMedia.SM]: {
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,
      },
      [BreakPointsMedia.XS]: {
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,
      },
      [BreakPointsMedia.XXS]: {
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,
      },
    },
  },
  {
    name: 'category-banner',
  },
);

export default useTemplateHeadingStyles;
